export default {
    "tickets.validation.approbationTab" : "Approbation",
}